module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gy-43c003e277ed5a4d0ca0ccb9dc4515fd.svg";